import './split.css';
export default {
  "modifiers": {
    "wrap": "pf-m-wrap",
    "fill": "pf-m-fill",
    "gutter": "pf-m-gutter"
  },
  "split": "pf-v6-l-split",
  "splitItem": "pf-v6-l-split__item"
};